export const BUSINESS_FILTER_ENABLED = 'BUSINESS_FILTER_ENABLED'
export const BUSINESS_FILTER_DISABLED = 'BUSINESS_FILTER_DISABLED'

function enable(businessFilter) {
  return {
    type: BUSINESS_FILTER_ENABLED,
    businessFilter,
  }
}

function disable() {
  return {
    type: BUSINESS_FILTER_DISABLED,
    BUSINESSFilter: null,
  }
}

export function enableBusinessFilter(filter) {
  return (dispatch) => {
    dispatch(enable(filter))
  }
}

export function disableBusinessFilter() {
  return (dispatch) => {
    dispatch(disable())
  }
}
